import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { FileUploadModule } from "ng2-file-upload";
import { FileManagerComponent } from "./file-manager.component";
import { IconsModule } from "app/components/icons";
import { CommonModule } from "@angular/common";
import { NgSelectModule } from "@ng-select/ng-select";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { CoreCommonModule } from "@core/common.module";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { RepositoryService } from "@repositories/services";
import { FileViewerModalComponent } from "./file-viewer-modal/file-viewer-modal.component";

@NgModule({
    declarations:[FileManagerComponent, FileViewerModalComponent],
    imports:[NgxDatatableModule, TranslateModule, FormsModule, FileUploadModule, CommonModule, NgSelectModule, NgbModule, CoreCommonModule, IconsModule, PdfViewerModule],
    // El visor reutiliza la detección de tipo de belivpedia (no es providedIn root)
    providers:[RepositoryService],
    exports:[FileManagerComponent]
})
export class FileManagerModule{}
